import { GzCustomTemplateListWebComponent } from './component/GzCustomTemplateListWebComponent';
import { WEB_COMPONENT_GZ_CUSTOM_TEMPLATE_LIST } from '../../webcomponents.constants';

export { GzCustomTemplateListWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_CUSTOM_TEMPLATE_LIST, GzCustomTemplateListWebComponent);
